import React from "react";
import styles from "./PartnerPromo.module.css";
import { Button } from "../Button/Button";

interface PartnerPromoProps {
  partnerQuantity: number;
  partnerQuantityText: string;
  title: string;
  text: string;
  buttonText: string;
  buttonUrl: string;
}

const PartnerPromo: React.FC<PartnerPromoProps> = ({
  partnerQuantity,
  partnerQuantityText,
  title,
  text,
  buttonText,
  buttonUrl,
}) => {
  return (
    <section className={styles.partnerPromo}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.leftColumn}>
            <div className={styles.quantityContainer}>
              <span className={styles.quantity}>{partnerQuantity}+</span>
              <span className={styles.quantityText}>{partnerQuantityText}</span>
            </div>
          </div>

          <div className={styles.rightColumn}>
            <div className={styles.textContent}>
              <h2 className={styles.title}>{title}</h2>
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </div>

            <div className={styles.actionContainer}>
              <Button
                className={styles.button}
                onClick={() => (window.location.href = buttonUrl)}
              >
                {buttonText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerPromo;
